import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout/Layout";
import { hidetoast, useDecodeToken } from "../../../Utils/function";
import { useNavigate } from "react-router-dom";
import StatePageUi from "./StatePageUi";
import {
  useDeleteStateMutation,
  useGetStateDataQuery,
} from "../../../store/Api/masterDataApi/state";
import {
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../../store/Api/common";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../../Utils/constant'

function StatePage() {
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  const [deleteState] = useDeleteStateMutation();
  const [deleteId, setDeleteId] = useState("");
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage:rowsPerPage ,
    currentPage: 1,
    rrbId: "",
    stateId: "",
    cityId: "",
  });
  const [filtersId, setFiltersId] = useState({
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    stateId: "",
    cityId: "",
  });
  const [selectData, setSelectData] = useState({
    rrb: [],
    city: [],
    states: [],
  });
  const { data, isFetching, isLoading, refetch } = useGetStateDataQuery({
    rrb_id: decodedToken?.role == 1 ? decodedToken?.rrb_id : tableQaury.rrbId,
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  const { data: rrb } = useGetRrbQuery({});
  const { data: states, refetch: refetchStates } = useGetStatesQuery(
    { rrbId: filtersId?.rrbId },
    {
      skip: !filtersId?.rrbId,
    }
  );
  const { data: city, refetch: refetchcity } = useGetCityQuery(
    { rrbId: filtersId?.rrbId, stateId: filtersId?.stateId },
    {
      skip: !filtersId?.rrbId || !filtersId?.stateId,
    }
  );
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
 
  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
      states: states?.data?.data,
      city: city?.data?.data,
    });
  }, [rrb, city, states]);
  // useEffect(() => {
  //   if (filtersId?.rrbId && filtersId?.stateId) {
  //     refetchcity();
  //   }
  // }, [filtersId]);

  useEffect(() => {
    if(filtersId?.rrbId) {
      setTableQaury({
        ...tableQaury,
        rrbId: filtersId?.rrbId,
        page: 1,
      });
    }
  },[filtersId])

  useEffect(() => {
    if (tableQaury?.rrbId || tableQaury?.stateId || tableQaury?.cityId) {
      refetch();
    }
  }, [tableQaury]);

  
  const onUpdate = (data) => {
    navigate(`/master-data/update-state`, { state: { data } });
  };
  const deleteCenFn = async () => {
    try {
      const response = await deleteState({ id: deleteId });
      if (response?.data?.success) {
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    ...((decodedToken?.role === 3 ||decodedToken?.role === 4)
      ? [{ title: "RRB", dataKey: "rrb_name" }]
      : []),

    { title: "State", dataKey: "name" },

    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          {/* <button className="border-0 bg-transparent">
                <i class="fas fa-eye text-primary"></i>
              </button> */}
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => onUpdate(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            data-toggle="modal"
            data-target="#modal-danger"
            onClick={() => setDeleteId(row?.id)}
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];
  const applyFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: filtersId?.rrbId,
      stateId: filtersId?.stateId,
      cityId: filtersId?.cityId,
      page: 1,
    });
  };

  const removeFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      stateId: "",
      cityId: "",
    });
    setFiltersId({
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      stateId: "",
      cityId: "",
    });
    setSelectData({
      rrb: rrb?.data?.data,
      states: decodedToken?.role == 1 ? states?.data : [],
      city: [],
    });
  };
  return (
    <Layout>
      <StatePageUi
        columns={columns}
        data={data?.data?.data || []}
        totalRecords={data?.data?.totalItems}
        loading={isLoading}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        deleteFn={deleteCenFn}
        setTableQaury={setTableQaury}
        selectData={selectData}
        setFiltersId={setFiltersId}
        refetchStates={refetchStates}
        refetchcity={refetchcity}
        setSelectData={setSelectData}
        filtersId={filtersId}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        toast={toast}
      />
    </Layout>
  );
}

export default StatePage;
